import ExtensionManager from "./ExtensionManager";
import reducer, { actions, types, selectors } from "./reducer";
import saga from "./saga";

export default ExtensionManager
export {
    actions,
    types,
    selectors,
    reducer,
    saga,
}
